import {LTServices} from '../lt-ng/lt-services';
import {PositionFeature} from "../lt-ng/map-controls/locate-me-control";
import {L} from "../lt-ng/landcare-toolkit";
import {ICoordinateAdjustmentService} from "./coordinate-adjustment";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import {Coordinate} from "ol/coordinate";
import {Geometry, Point} from "ol/geom";
import {transform} from "ol/proj";
import {IPortalServices} from "../lt-ng/portal-services";
interface IAddressSearchParameters {
	address: string;
}
export interface IPlaceNameSearchResource extends ng.resource.IResource<IPlaceNameSearchResource> {
	result: string;
	name?: string;
	x: number;
	y: number;
	zoomLevel?: number;
	pxid?: string;

	// Although all actions defined on IArticleResourceClass are avaiable with
	// the '$' prefix, we have the choice to expose only what we will use
	$publish(): IPlaceNameSearchResource;
	$unpublish(): IPlaceNameSearchResource;
}
export interface IAddressSearchResourceClass extends ng.resource.IResourceClass<IAddressSearchResource> {
	// Overload get to accept our custom parameters
	//get(): IAddressSearchResource;
	//get(params: IAddressSearchParameters, onSuccess: Function): IPlaceNameSearchResource;

	// Add our custom resource actions
	publish(): IPlaceNameSearchResource;
	publish(params: IAddressSearchParameters): IPlaceNameSearchResource;
	unpublish(params: IAddressSearchParameters): IPlaceNameSearchResource;
}
interface IPlaceNameSearchParameters {
	name: string;
}


// Let's define a custom resource
export interface IPlaceNameSearchResourceClass extends ng.resource.IResourceClass<IPlaceNameSearchResource> {
	// Overload get to accept our custom parameters
	//get(): IPlaceNameSearchResource;
	//get(params: IPlaceNameSearchParameters, onSuccess: Function): IPlaceNameSearchResource;

	// Add our custom resource actions
	publish(): IPlaceNameSearchResource;
	publish(params: IPlaceNameSearchParameters): IPlaceNameSearchResource;
	unpublish(params: IPlaceNameSearchParameters): IPlaceNameSearchResource;
}
export class PlaceNameSearchService {
	public static $inject = [
        'portalServices'
	];

	public url: string = `${this.portalServices.baseUri()}/simple_search/json?expression=:name&max_results=100&epsg=2193`;//http://ourenvironment.scinfo.org.nz/services/place_search/json?expression=Taur&max_results=5&epsg=2193&term=';
	constructor(protected portalServices: IPortalServices) {
	}
	public static getLongName(resource: IPlaceNameSearchResource): string {
		return resource.result;
	}
}
export class AddressSearchService {
	public static url: string = `/address-finder/address?format=json&q=:address=&max=100`;
	public static $inject = [];
}
export class SearchService {
	public static $inject = ['$http', 'coordinateAdjustmentService'];
	protected mapService: LTServices.IMapService;

	public setMapService(mapService : LTServices.IMapService) {
		this.mapService = mapService;
		if (mapService) {
			mapService.mapPromise.then((map) => map.addLayer(this.positionLayer));
		}
	}

	search: string;
	protected positionFeature = new PositionFeature('#FF3F3F');
	protected positionLayer : VectorLayer<VectorSource<Geometry>> = new VectorLayer(<any> {
		source: new VectorSource({
			features: [this.positionFeature]
		}),
		/// Ensure this is rendered above any of the maps main layers
		zIndex: L.util.Layer.zIndexForLayerType(L.layer.Type.CONTEXT, 888)  + 1
	});

	constructor(protected $http: ng.IHttpService, protected coordinateAdjustmentService: ICoordinateAdjustmentService) {
	}

	protected zoomDuration : number = 1000;

	/**
	 * Zoom to a coordinate, adjusting for the visible center of the map
	 * @param {Coordinate} coordinate
	 * @param {number} zoom
	 * @param callback
	 */
	public animateZoomTo(coordinate : Coordinate, zoom: number, callback: any = null) {
		let view = this.mapService.view;
		let center = this.coordinateAdjustmentService
			.adjustCentreForScreenSpace(coordinate, this.mapService.map, zoom);
		const interactions = [...this.mapService.map.getInteractions().getArray()];

		interactions.forEach(int => this.mapService.map.removeInteraction(int));
		const args = [{
			center,
			zoom,
			duration: this.zoomDuration
		}, (result) => {
			interactions.forEach(int => this.mapService.map.addInteraction(int));
			if (callback) callback(result);
			if (!result) {
				// fallback if the animation fails
				view.setCenter(center);
				view.setZoom(zoom);
			}
		}];

		// if (callback) args.push(callback);

		view.animate(...args);
	}

	public highlightLocation(coordinate : Coordinate, duration: number = 4000) {
		this.positionFeature.setGeometry(new Point(coordinate));
		this.positionLayer.setVisible(true);
		let visible = false;
		let times = Math.ceil(duration / 500);

		let flashingInterval = window.setInterval(() => {
			this.positionLayer.setVisible(visible);
			visible = !visible;
			times--;
			if(!times) {
				this.positionLayer.setVisible(false);
				window.clearInterval(flashingInterval)
			}
		}, 500);
	}

	open: (search: string) => void;
	addressGoTo(pxid: string): void {
		this.$http<IAddressResult>({
			method: 'GET',
			url: `https://api.addressfinder.io/api/nz/address/info?format=json&key=6282ce90-bfcc-012e-0b60-000c2987bf2e&pxid=${encodeURIComponent(pxid)}`, // &secret=4GX8J6KQ3CHDNTLUAR7V
			// url: `${window.location.pathname}addressInfo/${encodeURIComponent(pxid)}`
		}).then((result : ng.IHttpResponse<IAddressResult>) => {
			let lon: number = Number(result.data.x);
			let lat: number = Number(result.data.y);
			let coord = transform([lon, lat], 'EPSG:4326', 'EPSG:2193');
			this.animateZoomTo(coord, 9);

			this.highlightLocation(coord);
		});
	}
}

interface IAddressResult { x: string, y: string }

export interface IAddressSearchResource extends ng.resource.IResource<IPlaceNameSearchResource> {
	a: string;
	pxid: string;
	v: number;

	// Although all actions defined on IArticleResourceClass are avaiable with
	// the '$' prefix, we have the choice to expose only what we will use
	$publish(): IAddressSearchResource;
	$unpublish(): IAddressSearchResource;
}
